import React, { useEffect, useState } from 'react';
import { globalDragState, GlobalDragData } from './globalDragState';
import '../theme/minimized-sidepanel.css';
import '../theme/floating-panel.css';
import '../theme/side-panel.css';
export const GlobalDragGhost: React.FC = () => {
    const [dragData, setDragData] = useState<GlobalDragData | null>(null);
    useEffect(() => {
        const unsub = globalDragState.subscribe(setDragData);
        return () => {
            unsub();
        };
    }, []);
    if (!dragData || !dragData.isDragging || !dragData.dragGhostPos)
        return null;
    const pos = dragData.dragGhostPos;
    const icon = dragData.dragGhostIcon;
    // The fallback drag path (RegularSidePanel) publishes a plain label; tab
    // drags carry the full tab config — show whichever label is available.
    const label =
        (dragData.ghostData as { label?: string } | undefined)?.label ??
        (dragData.tabData as { label?: string } | undefined)?.label ??
        '';
    const style: React.CSSProperties = {
        position: 'fixed',
        left: pos.x + 8,
        top: pos.y + 8,
        zIndex: 99999,
        pointerEvents: 'none',
        opacity: 0.95,
        transition: 'none',
    };
    return (
        <div className="tab-drag-ghost" style={style} aria-hidden="true">
            {icon ?? null}
            {label ? <span>{label}</span> : null}
        </div>
    );
};
